/* cz-megamenu-v3.js - méga menus par marque (Apple Watch, Samsung, Huawei, Polar, Coros, Fitbit), 31/10/2026.
   Même panneau que Garmin (CSS du V2 repris dans assets/cz-megamenu-v3.json, isolé en Shadow DOM) : familles à gauche,
   modèles groupés par attache à droite, recherche, lien « Tout <marque> ». Les entrées de ces marques sont de simples
   liens du menu (pas de sous-menu Horizon) : le panneau est posé sous l'en-tête (position fixe) et s'ouvre au survol de
   l'entrée, sans toucher au menu de l'admin. Garmin et Accessoires (cz-megamenu-v2.js) ne sont pas concernés.
   Données : assets/cz-megamenu-v3.json (généré par code/megamenu/build_megamenu_marques.py) + snippets/cz-megamenu-v3-data.liquid
   (textes traduits, nombre de produits visibles par collection : un modèle dont la collection est masquée ou vide n'apparaît pas).
   Activation : window.CZ_MM3 = {json:'...', on:false}. ?mm3=1 active (mémorisé pour la session), ?mm3=0 coupe.
   Pour tous : on:true dans layout/theme.liquid. Écrans > 1000 px seulement. Si quoi que ce soit échoue, le lien simple reste. */
(function () {
  'use strict';
  var CFG = window.CZ_MM3 || {};
  if (!CFG.json) return;
  var m = location.search.match(/[?&]mm3=(\w+)/), flag = m && m[1], ses = null;
  try { if (flag === '1') sessionStorage.setItem('cz_mm3', '1'); else if (flag === '0') sessionStorage.removeItem('cz_mm3'); ses = sessionStorage.getItem('cz_mm3'); } catch (e) {}
  if (flag === '0' || !(CFG.on || flag === '1' || ses === '1')) return;
  var m2 = location.search.match(/[?&]mm2=(\w+)/); if (m2 && m2[1] === '0') return; /* comparaison avec l'ancien menu */
  var loc = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'fr';
  var desk = window.matchMedia('(min-width:1001px)');
  var DATA = null, loading = null;

  function js(id) { try { var e = document.getElementById(id); return e ? (JSON.parse(e.textContent) || {}) : {}; } catch (x) { return {}; } }
  var PD = js('cz-mm2-data'), P3 = js('cz-mm3-data');
  var I = {}, k; for (k in (PD.i18n || {})) I[k] = PD.i18n[k]; for (k in (P3.i18n || {})) I[k] = P3.i18n[k];
  var ROOT = (PD.root || '/').replace(/\/$/, ''), OK = P3.ok || null, U = P3.u || {}, PK = P3.p || {}, G = P3.g || {};
  function t(key, vars) {
    var v = I[key]; if (!v || /translation missing/i.test(v)) v = (DATA && DATA.fr && DATA.fr[key]) || '';
    if (vars) for (var x in vars) v = v.split('[' + x + ']').join(vars[x]);
    return v;
  }
  function ready() {
    if (/^fr/i.test(loc)) return true;
    var fr = (DATA && DATA.fr) || {}, ks = Object.keys(fr), d = 0;
    ks.forEach(function (x) { if (I[x] && I[x] !== fr[x] && !/translation missing/i.test(I[x])) d++; });
    return ks.length > 0 && d / ks.length >= 0.6;
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function ev(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }
  function load() {
    return loading || (loading = fetch(CFG.json, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('json'); return r.json(); }).then(function (d) { DATA = d; return d; }));
  }
  function ok(h) { return !OK || (OK[h] | 0) > 0; }
  function url(h) { return ROOT + '/collections/' + h; }
  function norm(h) {
    if (!h) return '';
    try { h = new URL(h, location.origin).pathname; } catch (e) {}
    try { h = decodeURIComponent(h); } catch (e) {}
    return h.replace(/\/+$/, '').toLowerCase();
  }

  /* ---------- données filtrées (collections en ligne avec au moins 1 produit) ---------- */
  function brandData(b) {
    var B = DATA.brands[b]; if (!B || !ok(B.all)) return null;
    var fams = [];
    B.fams.forEach(function (f) {
      var cards = [];
      f.cards.forEach(function (c) { var ms = c.m.filter(function (x) { return ok(x.c); }); if (ms.length) cards.push({ t: c.t, h: ok(c.h) ? c.h : B.all, m: ms }); });
      var n = cards.reduce(function (a, c) { return a + c.m.length; }, 0);
      if (!n) return;
      /* « Les plus choisis » : seulement pour une petite famille (12 modèles, 2 attaches au plus) et une source sans risque d'attache incompatible */
      var src = (f.h !== B.all && ok(f.h)) ? f.h : cards.length === 1 ? cards[0].h : b === 'apple' ? B.all : null, sub = '';
      /* plusieurs attaches sans collection commune : produits de la 1re attache, nommée dans le titre */
      if (cards.length === 2 && b !== 'apple') { src = cards[0].h !== B.all ? cards[0].h : null; sub = cards[0].t; }
      var pk = (src && n <= 12 && cards.length <= 2 && PK[src]) ? PK[src].slice(0, 4) : [];
      fams.push({ n: f.o ? t('mm_others') : f.n, s: f.s, h: ok(f.h) ? f.h : B.all, cards: cards, nb: n, pk: pk.length >= 2 ? pk : [], pks: sub });
    });
    var g = G[b] && G[b].u && G[b].t && !/translation missing/i.test(G[b].t) ? G[b] : null;
    return fams.length ? { name: B.name, all: B.all, fams: fams, g: g } : null;
  }
  function nbTxt(n) { return n === 1 ? t('mm_model_1') : t('mm_models_n', { NB: n }); }

  function html(b, D) {
    var h = '<div class="mega" id="mm-' + b + '"><div class="wrap"><div class="rail"><div class="search"><input id="q" type="search" autocomplete="off" placeholder="' + esc(t('mm_search')) + '" aria-label="' + esc(t('mm_search_aria_brand', { MARQUE: D.name })) + '"></div>' +
      '<a class="all" href="' + esc(url(D.all)) + '"><span>' + esc(t('mm_all_brand', { MARQUE: D.name })) + '</span><span aria-hidden="true">→</span></a><div class="fams">';
    D.fams.forEach(function (f, i) { h += '<a class="fam" data-i="' + i + '" aria-controls="p' + i + '" href="' + esc(url(f.h)) + '"><span>' + esc(f.n) + '</span><em>' + f.nb + '</em></a>'; });
    h += '</div>' + (D.g ? '<a class="guide" style="' + GUIDE_CSS + '" href="' + esc(D.g.u) + '">' + esc(D.g.t) + '</a>' : '') + '</div><div class="body">';
    D.fams.forEach(function (f, i) {
      var nc = f.cards.length;
      h += '<section class="pan" id="p' + i + '" role="region" aria-label="' + esc(f.n) + '"' + (i ? ' hidden' : '') + '><div class="ph"><div><h3>' + esc(f.n) + '</h3><p>' + esc(nbTxt(f.nb)) + '</p></div>' +
        '<a class="btn" href="' + esc(url(f.h)) + '"><span>' + esc(t('mm_see_all')) + '</span><span class="bl">' + esc(t('mm_see_all_long', { SERIE: f.s })) + '</span><span aria-hidden="true">→</span></a>' +
        '<button type="button" class="mmx" aria-label="' + esc(t('mm_close')) + '">&#10005;</button></div>' + (f.pk.length ? '<div class="pw">' : '') + '<div class="cards" style="--n:' + nc + '">';
      f.cards.forEach(function (c) {
        var cc = f.pk.length ? 1 : nc === 1 ? Math.min(4, Math.max(1, Math.ceil(c.m.length / 7))) : nc === 2 ? Math.min(2, Math.max(1, Math.ceil(c.m.length / 9))) : 1;
        h += '<div class="card" style="--cc:' + cc + ';--rows:' + Math.ceil(c.m.length / cc) + '"><div class="ch"><b>' + esc(c.t) + '</b><span>' + esc(nbTxt(c.m.length)) + '</span><a class="cl" href="' + esc(url(c.h)) + '"><span>' + esc(t('mm_see_more')) + '</span> →</a></div><div class="cw"><div class="chips">' +
          c.m.map(function (x) { return '<a class="chip" href="' + esc(url(x.c)) + '" title="' + esc(x.n) + '">' + x.d + '</a>'; }).join('') + '</div><i class="hint" aria-hidden="true"></i></div></div>';
      });
      h += '</div>';
      if (f.pk.length) h += '<aside class="picks"><div class="ch"><b>' + esc(P3.best || '') + '</b>' + (f.pks ? '<span>' + esc(f.pks) + '</span>' : '') + '</div><div class="pk">' + f.pk.map(function (x) {
        var nm = String(x.t).split(' | ')[0], mt = (String(x.t).match(/\(([^()]*)\)[^()]*$/) || [])[1] || '';
        return '<a class="pc" href="' + esc(ROOT + '/products/' + x.h) + '"><img src="' + esc(x.i) + '" alt="" width="240" height="180" loading="lazy"><b>' + esc(nm) + '</b>' + (mt ? '<small>' + esc(mt) + '</small>' : '') + '<em>' + esc(x.v ? t('mm_from', { PRIX: x.p }) : x.p) + '</em></a>';
      }).join('') + '</div></aside></div>';
      h += '</section>';
    });
    h += '<div class="res" id="res" hidden></div><div class="foot"><span>' + esc(t('mm_foot_sort')) + '</span></div><i class="bhint" aria-hidden="true"></i></div></div></div>';
    return h;
  }

  /* ---------- panneaux ---------- */
  var hosts = {}, cur = null, curLi = null, tOpen = 0, tClose = 0;
  function header() { return document.querySelector('header-component') || document.querySelector('#header-component') || document.querySelector('header'); }
  function place(host) {
    var hd = header(); if (!hd) return;
    var r = hd.getBoundingClientRect(), b = Math.max(0, Math.round(r.bottom));
    host.style.top = b + 'px'; host.style.setProperty('--mm-top', b + 'px');
  }
  function hostFor(b) {
    if (hosts[b]) return hosts[b];
    var D = brandData(b); if (!D) return (hosts[b] = null);
    var host = document.createElement('div'); host.className = 'cz-mm3-host'; host.setAttribute('data-brand', b); host.hidden = true;
    host.style.cssText = 'position:fixed;left:0;right:0;top:0;z-index:' + zi() + ';pointer-events:none;--mm-strip:24px';
    var sr = host.attachShadow({ mode: 'open' });
    sr.innerHTML = '<style>' + DATA.css + ':host([hidden]){display:none!important}</style>' + html(b, D);
    document.body.appendChild(host);
    host.addEventListener('pointerenter', function () { clearTimeout(tClose); cancelPend(); clearTimeout(gT); });
    host.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') closeSoon(); });
    host.addEventListener('focusout', function (e) { if (!e.relatedTarget || (!host.contains(e.relatedTarget) && !(curLi && curLi.contains(e.relatedTarget)))) setTimeout(function () { if (!host.shadowRoot.activeElement && !(curLi && curLi.contains(document.activeElement))) closeNow(); }, 0); });
    init(sr, b, D, host);
    return (hosts[b] = host);
  }
  function zi() { var hd = header(), z = 0, e = hd; while (e && e !== document.body) { var v = parseInt(getComputedStyle(e).zIndex, 10); if (v > z) z = v; e = e.parentElement; } return Math.max(z, 20); }
  function open(b, li) {
    clearTimeout(tClose);
    if (cur === b) return;
    var host = hostFor(b); if (!host) return;
    closeNow();
    place(host); host.hidden = false; cur = b; curLi = li; li.classList.add('cz-mm3-open');
    host.__fit && host.__fit();
  }
  function closeNow() {
    clearTimeout(tClose); clearTimeout(tOpen);
    if (!cur) return;
    var h = hosts[cur]; if (h) h.hidden = true;
    if (curLi) curLi.classList.remove('cz-mm3-open');
    cur = null; curLi = null;
  }
  function closeSoon() { clearTimeout(tClose); tClose = setTimeout(closeNow, 260); }

  function init(sr, b, D, host) {
    var $ = function (s) { return sr.querySelector(s); }, $$ = function (s) { return [].slice.call(sr.querySelectorAll(s)); };
    var fams = $$('.fam'), pans = $$('.pan'), q = $('#q'), res = $('#res'), cur0 = 0, timer, body = $('.body');
    function show(i) {
      cur0 = i;
      fams.forEach(function (f, j) { f.classList.toggle('on', j == i); if (j == i) f.setAttribute('aria-current', 'true'); else f.removeAttribute('aria-current'); });
      pans.forEach(function (p, j) { p.hidden = (j != i); });
      fitSoon();
    }
    fams.forEach(function (f, i) {
      f.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { if ((q.value || '').trim().length < 2) show(i); }, 90); });
      f.addEventListener('mouseleave', function () { clearTimeout(timer); });
      f.addEventListener('focus', function () { if ((q.value || '').trim().length < 2) show(i); });
      f.addEventListener('click', function (e) { if (!f.classList.contains('on')) { e.preventDefault(); q.value = ''; clearSearch(); show(i); } });
      f.addEventListener('keydown', function (e) {
        var d = e.key == 'ArrowDown' ? 1 : e.key == 'ArrowUp' ? -1 : 0;
        if (d) { e.preventDefault(); fams[(i + d + fams.length) % fams.length].focus(); return; }
        if (e.key == 'ArrowRight') { var c = $('.pan:not([hidden]) .chip'); if (c) { e.preventDefault(); c.focus(); } }
      });
    });
    show(0);
    sr.addEventListener('click', function (e) { var x = e.target.closest && e.target.closest('.mmx'); if (x) { e.preventDefault(); closeNow(); } });
    sr.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a'); if (!a) return;
      var cl = a.classList, pan = a.closest('.pan');
      var type = cl.contains('chip') ? 'modele' : cl.contains('fam') ? 'serie' : cl.contains('cl') ? 'tout_voir_attache' : cl.contains('btn') ? 'voir_tous' : cl.contains('pc') ? 'produit' : cl.contains('guide') ? 'guide' : cl.contains('all') ? 'tout_marque' : 'autre';
      ev({ event: 'mega_menu_click', menu: b, type: type, serie: pan ? pan.getAttribute('aria-label') : '', libelle: a.textContent.trim().replace(/\s+/g, ' ').slice(0, 60), href: a.getAttribute('href') });
    }, true);
    sr.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.preventDefault(); var li = curLi; closeNow(); var a = li && li.querySelector('a.menu-list__link'); if (a) a.focus();
    });
    /* recherche (modèles de la marque) */
    var models = [];
    D.fams.forEach(function (f) { f.cards.forEach(function (c) { c.m.forEach(function (x) { models.push({ n: x.n, c: x.c, a: c.t }); }); }); });
    function clearSearch() { res.hidden = true; pans.forEach(function (p, j) { p.hidden = (j != cur0); }); fams.forEach(function (f, j) { f.classList.toggle('on', j == cur0); }); fitSoon(); }
    q.addEventListener('input', function () {
      var v = q.value.trim().toLowerCase();
      if (v.length < 2) { clearSearch(); return; }
      var w = v.split(/\s+/), r = models.filter(function (d) { var s = d.n.toLowerCase(); return w.every(function (x) { return s.indexOf(x) > -1; }); });
      pans.forEach(function (p) { p.hidden = true; }); fams.forEach(function (f) { f.classList.remove('on'); }); res.hidden = false;
      res.innerHTML = r.length ? '<div class="ph"><div><h3>' + esc(r.length === 1 ? t('mm_res_1') : t('mm_res_n', { NB: r.length })) + '</h3><p>' + esc(t('mm_res_hint')) + '</p></div><button type="button" class="mmx" aria-label="' + esc(t('mm_close')) + '">&#10005;</button></div><div class="rl" style="margin-top:14px">' + r.slice(0, 40).map(function (d) { return '<a class="chip" href="' + esc(url(d.c)) + '">' + esc(d.n) + '<small>' + esc(d.a) + '</small></a>'; }).join('') + '</div>' : '<div class="empty">' + esc(t('mm_res_none', { REQ: q.value })) + ' <a class="btn" style="margin-left:8px" href="' + esc(url(D.all)) + '">' + esc(t('mm_res_all_brand', { MARQUE: D.name })) + '</a></div>';
      ev({ event: 'mega_menu_search', menu: b, terme: v, resultats: r.length });
    });
    q.addEventListener('keydown', function (e) { var a = res.hidden ? null : res.querySelector('a.chip'); if (e.key == 'ArrowDown') { e.preventDefault(); (a || fams[0]).focus(); } if (e.key == 'Enter' && a) { e.preventDefault(); a.click(); } if (e.key == 'Escape' && q.value) { e.stopPropagation(); q.value = ''; clearSearch(); } });
    /* indices de défilement */
    function updCue(c) { c.parentNode.classList.toggle('more', c.scrollHeight > c.clientHeight + 2 && c.scrollTop + c.clientHeight < c.scrollHeight - 4); }
    function updBody() { if (body) body.classList.toggle('more', body.scrollHeight > body.clientHeight + 2 && body.scrollTop + body.clientHeight < body.scrollHeight - 4); }
    $$('.chips').forEach(function (c) { c.addEventListener('scroll', function () { updCue(c); }, { passive: true }); });
    if (body) body.addEventListener('scroll', updBody, { passive: true });
    var fitT = 0;
    function fit() { if (host.hidden) return; $$('.chips').forEach(updCue); updBody(); }
    function fitSoon() { clearTimeout(fitT); fitT = setTimeout(fit, 40); }
    host.__fit = fitSoon;
    window.addEventListener('resize', function () { if (!host.hidden) { place(host); fitSoon(); } });
  }

  /* ---------- entrées du menu ---------- */
  function brandOf(li) {
    if (!DATA || li.getAttribute('slot') || li.querySelector('.menu-list__submenu') || li.classList.contains('cz-gmm-item')) return null;
    var a = li.querySelector('a.menu-list__link'); if (!a) return null;
    var p = norm(a.getAttribute('href'));
    for (var b in DATA.brands) { var h = DATA.brands[b].all; if (p === norm(U[h]) || p === norm(url(h))) return b; }
    return null;
  }
  var GUIDE_CSS = 'display:block;flex:none;white-space:normal;overflow-wrap:anywhere;margin:auto 12px 0;padding:10px 2px 2px;border-top:1px solid #e3e3e6;font-size:12.5px;font-weight:600;line-height:1.35;color:#1d1d1f;text-decoration:underline;text-underline-offset:3px';
  function garminGuide() {
    var g = G.garmin; if (!g || !g.u || !g.t || /translation missing/i.test(g.t)) return;
    var h = document.querySelector('header-menu li.cz-gmm-item .cz-mm2-host'), sr = h && h.shadowRoot, r = sr && sr.querySelector('.rail');
    if (!r || r.querySelector('.czg')) return;
    /* en bas de la colonne des séries (place libre) : le pied et les listes du panneau Garmin ne bougent pas */
    var a = document.createElement('a'); a.className = 'czg'; a.href = g.u; a.textContent = g.t;
    a.style.cssText = GUIDE_CSS; r.appendChild(a);
  }
  var wired = typeof WeakSet === 'function' ? new WeakSet() : null;
  function wire() {
    garminGuide();
    if (!DATA || !wired) return;
    [].forEach.call(document.querySelectorAll('header-menu li.menu-list__list-item'), function (li) {
      if (wired.has(li)) return; wired.add(li);
      li.addEventListener('pointerenter', function (e) {
        if (li.classList.contains('cz-gmm-item')) setTimeout(garminGuide, 60);
        if (e.pointerType === 'touch' || !desk.matches || !ready()) return;
        var b = brandOf(li);
        if (!b) { closeNow(); return; }
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(b, li); }, cur ? 0 : 70);
      });
      li.addEventListener('pointerleave', function (e) { clearTimeout(tOpen); if (cur && curLi === li && e.pointerType !== 'touch') closeSoon(); });
      li.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' || !desk.matches || !ready()) return;
        var b = brandOf(li); if (!b) return;
        e.preventDefault(); open(b, li); var h = hosts[b]; if (h) { var i = h.shadowRoot.querySelector('#q'); if (i) i.focus(); }
      });
    });
  }
  /* ---------- intention au survol (250 ms) ----------
     Quand un panneau est ouvert (une marque ou un sous-menu Horizon comme Garmin), passer sur une autre entrée
     du menu ne bascule qu'après 250 ms passées dessus : traverser une entrée en allant vers le panneau ne change rien. */
  var pend = null, pendT = 0, INTENT = 250;
  function itemOf(n) { return n instanceof Element ? n.closest('header-menu li.menu-list__list-item') : null; }
  function openItem() {
    if (cur && curLi) return curLi;
    var x = document.querySelector('header-menu li.menu-list__list-item:not([slot="more"]) [aria-expanded="true"]');
    return x ? itemOf(x) : null;
  }
  function pass(li, type, rel) { var ev; try { ev = new PointerEvent(type, { pointerType: 'mouse', relatedTarget: rel || null }); } catch (x) { ev = new Event(type); } ev.__cz = true; li.dispatchEvent(ev); }
  function cancelPend() { clearTimeout(pendT); pend = null; }
  function commit(li, from) {
    pend = null;
    if (!li.matches(':hover')) return;
    var b = brandOf(li);
    if (b) open(b, li); else closeNow();
    if (from && from !== li && !cur) pass(from, 'pointerleave', li);
    pass(li, 'pointerenter');
  }
  function armed(e) { return !e.__cz && e.pointerType !== 'touch' && desk.matches && DATA && ready(); }
  window.addEventListener('pointerenter', function (e) {
    var li = e.target; if (!(li instanceof Element) || !li.matches('header-menu li.menu-list__list-item') || !armed(e)) return;
    var o = openItem(); if (!o || o === li) { if (o === li) { cancelPend(); clearTimeout(gT); } return; }
    e.stopPropagation(); cancelPend(); pend = li;
    pendT = setTimeout(function () { if (pend === li) commit(li, o); }, INTENT);
  }, true);
  /* écouteurs sur window (phase de capture) : ils passent avant ceux d'Horizon, posés sur document */
  var gT = 0;
  function ourHovered() { return !!(cur && hosts[cur] && hosts[cur].matches(':hover')); }
  /* sortie de l'entrée ouverte : on attend l'intention avant de fermer (le pointeur peut rejoindre le panneau) */
  function grace(o) {
    clearTimeout(gT);
    gT = setTimeout(function () {
      if (openItem() !== o || pend) return;
      if (o.matches(':hover') || ourHovered()) return;
      if (cur && curLi === o) closeNow(); else pass(o, 'pointerleave', null);
    }, INTENT);
  }
  window.addEventListener('pointerleave', function (e) {
    var li = e.target; if (!(li instanceof Element) || !li.matches('header-menu li.menu-list__list-item') || !armed(e)) return;
    var o = openItem(); if (!o) return;
    if (li === pend) { e.stopPropagation(); cancelPend(); grace(o); return; }
    if (li === o) { e.stopPropagation(); grace(o); }
  }, true);
  /* Horizon ferme aussi son sous-menu en suivant le pointeur (pointermove) : tant que le sien est ouvert et que le
     pointeur est hors de son entrée, ce suivi attend la décision ci-dessus */
  window.addEventListener('pointermove', function (e) {
    if (cur || !armed(e)) return;
    var o = openItem(); if (!o) return;
    if (!(e.target instanceof Node && o.contains(e.target))) e.stopPropagation();
  }, true);

  var st = document.createElement('style');
  st.textContent = 'header-menu li.cz-mm3-open>a.menu-list__link,header-menu li.cz-mm3-open .menu-list__link-title{opacity:.62}';
  document.head.appendChild(st);
  document.addEventListener('pointerdown', function (e) { if (!cur) return; var h = hosts[cur]; if (h && (h === e.target || h.contains(e.target))) return; if (curLi && curLi.contains(e.target)) return; closeNow(); }, true);
  window.addEventListener('scroll', function () { if (!cur) return; var h = hosts[cur], hd = header(); if (!h || !hd) return; if (hd.getBoundingClientRect().bottom <= 0) closeNow(); else place(h); }, { passive: true });
  desk.addEventListener && desk.addEventListener('change', function () { if (!desk.matches) closeNow(); });

  function start() {
    load().then(function () {
      if (!ready()) return;
      wire();
      /* pointeur déjà sur une entrée de marque pendant le chargement : on ouvre */
      if (desk.matches) [].forEach.call(document.querySelectorAll('header-menu li.menu-list__list-item'), function (li) { var b = li.matches(':hover') && brandOf(li); if (b) open(b, li); });
      var hm = header() || document.body, tm = 0;
      if (window.MutationObserver) new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(wire, 80); }).observe(hm, { childList: true, subtree: true });
    }).catch(function () {});
  }
  function whenIdle(f) { (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(f, { timeout: 2500 }); }
  var kick = function () {
    /* survol avant la fin du chargement des données : on charge tout de suite */
    var hm = document.querySelector('header-menu');
    if (hm) hm.addEventListener('pointerover', function once() { hm.removeEventListener('pointerover', once); start(); }, { passive: true });
    whenIdle(start);
  };
  var started = false, s0 = start; start = function () { if (started) return; started = true; s0(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick); else kick();
})();
